import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-chatbot" }
const _hoisted_2 = { class: "container-lil" }
const _hoisted_3 = { class: "flex flex-col align-items-center mb-10" }
const _hoisted_4 = { class: "widget-chatbot h-auto flex flex-col align-items-center px-5 py-6 mb-7" }
const _hoisted_5 = { class: "flex-center mb-5" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "mb-10" }
const _hoisted_8 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_12 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_13 = { class: "grid-web3 mt-5" }
const _hoisted_14 = { class: "card px-2 py-2" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "font-semibold text-black mt-3 mb-4 px-4" }
const _hoisted_17 = {
  key: 0,
  class: "text-center my-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "secondary-font flex-center gap-4 my-2" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-aide-tchat.svg",
              class: "size-base mt--2",
              alt: ""
            }),
            _createTextVNode(" Live Tchat ")
          ], -1)),
          _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "secondary-font text-center my-5" }, " Discuter avec un conseiller client ", -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatAvatars, (avatar, index) => {
              return (_openBlock(), _createElementBlock("img", {
                key: index,
                src: avatar,
                class: "size-2xl rounded-100 mx-2 my-2",
                alt: "Conseiller client"
              }, null, 8, _hoisted_6))
            }), 128))
          ]),
          _createElementVNode("button", {
            class: "btn lg icon-right btn-chatbot flex-center px-10 gap-2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openLiveChat && _ctx.openLiveChat(...args)))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", null, "Démarrer  ", -1),
            _createElementVNode("img", {
              src: "/public/icons/icon-send.svg",
              class: "btn-icon",
              alt: ""
            }, null, -1)
          ]))])
        ]),
        _createElementVNode("button", {
          class: "btn lg btn-chatbot flex-center px-10 gap-2 mb-5",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openWhatsApp && _ctx.openWhatsApp(...args)))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("img", {
            src: "/public/icons/icon-aide-whatsapp.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1),
          _createElementVNode("span", null, "Discuter sur WhatsApp", -1)
        ]))]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
        _createElementVNode("button", {
          class: "btn lg btn-chatbot flex-center px-10 gap-2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.makePhoneCall && _ctx.makePhoneCall(...args)))
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("img", {
            src: "/public/icons/icon-aide-appel.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1),
          _createElementVNode("span", null, "Service client", -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "secondary-font flex-center gap-4 my-2" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-aide-faq.svg",
            class: "size-base mt--2",
            alt: ""
          }),
          _createTextVNode(" FAQ ")
        ], -1)),
        (_ctx.loadingFaqs)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Chargement des questions..."))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (faq, faqIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: faq.id || faqIndex,
                  class: "faq-wrapper"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn-faq", { 'active': _ctx.expandedFaqs[faq.id || faqIndex] }]),
                    onClick: ($event: any) => (_ctx.toggleFaq(faq.id || faqIndex))
                  }, [
                    _createTextVNode(_toDisplayString(faq.question || faq.libelle) + " ", 1),
                    _cache[9] || (_cache[9] = _createElementVNode("img", {
                      src: "/public/icons/icon-arrow-faq.svg",
                      class: "size-xs icon-black faq-icon",
                      alt: ""
                    }, null, -1))
                  ], 10, _hoisted_9),
                  _createElementVNode("p", {
                    class: _normalizeClass(["faq-content", { 'active': _ctx.expandedFaqs[faq.id || faqIndex] }]),
                    innerHTML: faq.reponse || faq.contenu_aide
                  }, null, 10, _hoisted_10)
                ]))
              }), 128)),
              (_ctx.faqs.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("p", null, "Aucune FAQ disponible pour le moment.", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ], 64)),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        _createVNode(_component_router_link, { to: "/front/aide/faq" }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createElementVNode("h5", { class: "flex-center gap-4 text-black" }, [
              _createTextVNode(" Voir toutes les questions "),
              _createElementVNode("img", {
                src: "/public/icons/icon-go.svg",
                class: "size-medium",
                alt: ""
              })
            ], -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
      _createElementVNode("div", null, [
        _cache[16] || (_cache[16] = _createElementVNode("h1", { class: "secondary-font flex-center gap-4 my-2" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-aide-tutoriel.svg",
            class: "size-base mt--2",
            alt: ""
          }),
          _createTextVNode(" Tutoriels ")
        ], -1)),
        (_ctx.loadingTutoriels)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Chargement des tutoriels..."))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tutoriels.slice(0, 3), (tutoriel) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: tutoriel.id,
                    to: `/front/aide/tutoriels/${tutoriel.slug || tutoriel.id}`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("img", {
                          src: _ctx.getTutorielImage(tutoriel),
                          width: "100%",
                          class: "rounded-15",
                          alt: ""
                        }, null, 8, _hoisted_15),
                        _createElementVNode("h5", _hoisted_16, _toDisplayString(tutoriel.libelle || tutoriel.titre), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ]),
              (_ctx.tutoriels.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("p", null, "Aucun tutoriel disponible pour le moment.", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ], 64)),
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        _createVNode(_component_router_link, { to: "/front/aide/tutoriels" }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
            _createElementVNode("h5", { class: "flex-center gap-4 text-black" }, [
              _createTextVNode(" Voir tous les tutoriels "),
              _createElementVNode("img", {
                src: "/public/icons/icon-go.svg",
                class: "size-medium",
                alt: ""
              })
            ], -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "clear-both h-70" }, null, -1))
    ])
  ]))
}